import { IconKeys } from '../Icon/IconKeys';
import { AlertRisksKeys } from '../../../API/types/Alerts';
import { FocusedAlert } from '../../../store/AlertFocusStore';

export type CalendarItemType = {
  _id?: string;
  detailsId: string;
  type: string;
  date: string;
  thumbnailUrl?: string | null;
  title: string;
  subtitle?: string;
  vehicle?: string;
  updatedAt?: string;
  isMergedTrip?: boolean;
  /** Alert rows carry what the map needs to draw the matching marker on hover/click. */
  alert?: FocusedAlert;
  riskLevel?: AlertRisksKeys;
  tripPhase?: 'start' | 'end';
};

export const iconKeysByType: Record<string, IconKeys> = {
  alert: IconKeys.LIGHTNING,
  trip: IconKeys.CAR,
};
